import {
  Box,
  HStack,
  VStack,
  Text,
  Circle,
  useBoolean,
  Icon,
} from '@wegroup/design-system';
import React from 'react';
import SingleSelectedSubOffer from './OfferSidebarSingleSelectedSubOffer';
import { useDispatch } from 'react-redux';
import { setPreferredOffer } from '../../../../../store/redux/slices/offersSlice';
import { useLouiseSelector } from '../../../../../store/redux/store';
import SinglePreferredOffer from './OfferSidebarSinglePreferredOffer';

interface Props {
  icon: React.ReactElement;
  title: string;
  riskObject: string;
  preferredOfferId: string;
  multiple?: boolean;
}

const OffersSidebarSingleSelectedOffer: React.FC<
  React.PropsWithChildren<Props>
> = ({
  icon,
  title,
  multiple,
  riskObject,
  preferredOfferId,
  ...otherProps
}) => {
  const dispatch = useDispatch();
  const selectedOffers = useLouiseSelector(
    (state) => state.offers.selectedOffers,
  );

  const [isSubMenuOpen, setIsSubMenuOpen] = useBoolean(false);

  const choosePreferredOffer = (quoteId: string) =>
    dispatch(setPreferredOffer({ riskObject, id: quoteId }));

  return (
    <VStack
      spacing={2}
      width="100%"
      data-test-id="ADVISORY-CONVO_OFFERS_SELECTED-OFFER_WRAPPER"
    >
      <HStack width="100%" spacing={2} fontSize="md" {...otherProps}>
        <Box borderRadius="6px" backgroundColor="gray.ultraLight" padding={1}>
          {icon}
        </Box>
        <VStack align="flex-start" justify="center" flexGrow={1} minH="12">
          <Text>{title}</Text>
          <SinglePreferredOffer
            riskObject={riskObject}
            preferredOfferId={preferredOfferId}
          />
        </VStack>
        {multiple && (
          <Circle
            backgroundColor="primary.50"
            cursor="pointer"
            onClick={setIsSubMenuOpen.toggle}
            transform={isSubMenuOpen ? 'rotate(180deg)' : ''}
            transition="0.2s"
          >
            <Icon name="GeneralActionsChevronDownRounded" color="primary.500" />
          </Circle>
        )}
      </HStack>
      {multiple && isSubMenuOpen && (
        <VStack width="100%" spacing={3}>
          {selectedOffers[riskObject].map((id) => (
            <SingleSelectedSubOffer
              key={`selected_offer_box${id}`}
              riskObject={riskObject}
              id={id}
              onClick={() => choosePreferredOffer(id)}
              isSelected={id === preferredOfferId}
            />
          ))}
        </VStack>
      )}
    </VStack>
  );
};

export default OffersSidebarSingleSelectedOffer;
